import { Icon, ICONS } from '@/common/components/Icon';
import { ActionIcon, Box, Group, Text, Tooltip } from '@mantine/core';
import { IconExternalLink } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function NoteListItem({
    noteId,
    noteTitle,
    onClick,
}: {
    noteId: string;
    noteTitle: string;
    onClick?: () => void;
}) {
    const [isHovered, setIsHovered] = useState(false);
    const { t } = useTranslation('note');

    return (
        <Link
            to={`/note/${noteId}`}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Box
                px={8}
                bg={isHovered ? 'gray.0' : 'transparent'}
                style={{ borderRadius: '8px' }}
            >
                <Group h={36} gap={4} justify="center" align="center">
                    <Icon name={ICONS.NOTE.NOTE} size={14} />
                    <Text size="xs" flex={1} lineClamp={1}>
                        {noteTitle}
                    </Text>
                    {isHovered && (
                        <Tooltip label={t('actions.open_new_window')} withArrow>
                            <ActionIcon
                                variant="default"
                                color="gray"
                                size="sm"
                                onClick={e => {
                                    e.stopPropagation();
                                    e.preventDefault();

                                    window.open(`/note/${noteId}`, '_blank');
                                }}
                            >
                                <IconExternalLink size={14} />
                            </ActionIcon>
                        </Tooltip>
                    )}
                </Group>
            </Box>
        </Link>
    );
}
